export default __webpack_public_path__ + "static/media/test4.1f7e6791.png";